import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Typography } from '@/components/ui/typography';
import OrderServicePhotoPane from '@/components/property-assets-management/order-service-modal/OrderServicePhotoPane';
import type { GroupedAssetRow } from '../utils/cartTransforms';
import { useAssetCartEdit } from '../hooks/useAssetCartEdit';

type AssetCartEditModalProps = {
  row: GroupedAssetRow;
  updateAssetGroup: (p: { lineItemUUID?: string; lineAssetId: string; lineSlug: string; removedRefIds: string[]; note: string }) => Promise<void>;
  removeAssetItem: (lineItemUUID: string | undefined, assetId: string, slug: string) => Promise<void>;
  onClose: () => void;
};

export default function AssetCartEditModal({ row, updateAssetGroup, removeAssetItem, onClose }: AssetCartEditModalProps): JSX.Element {
  const edit = useAssetCartEdit({ row, updateAssetGroup, removeAssetItem, onClose });

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-[560px] p-0 gap-0 overflow-hidden" onPointerDownOutside={(e) => e.preventDefault()}>
        <div className="flex items-center border-b border-border px-6 py-4">
          <DialogTitle asChild>
            <Typography variant="heading-lg">Edit {edit.serviceName}</Typography>
          </DialogTitle>
        </div>

        <OrderServicePhotoPane
          serviceName={edit.serviceName}
          unitPriceText={edit.unitPriceText}
          addressLine={edit.addressLine}
          photos={edit.photos}
          note={edit.note}
          onNoteChange={edit.setNote}
          onRemovePhoto={edit.removePhoto}
          noteRequired={edit.noteRequired}
        />

        <div className="flex justify-end gap-3 border-t border-border px-6 py-4">
          <Button variant="outline" onClick={edit.cancel} disabled={edit.saving}>Cancel</Button>
          <Button onClick={edit.save} disabled={!edit.canSave || edit.saving}>
            {edit.saving ? 'Saving…' : 'Save Changes'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
